"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@/store/auth.store";
import { useAddressStore } from "@/store/address.store";

/**
 * Envoie sur `/home` qui n'a plus rien à faire sur la vitrine.
 *
 * La landing existe pour deux choses : convaincre, et récolter une adresse.
 * Un client connecté, ou un visiteur qui a déjà désigné où il est, a répondu
 * aux deux — le laisser sur la page marketing lui impose un détour avant
 * d'arriver à ce qu'il vient chercher.
 *
 * Volontairement CÔTÉ CLIENT. Décider côté serveur imposerait de lire le
 * cookie d'authentification, ce qui ferait sortir `/` du rendu statique : la
 * page la plus autoritaire du domaine serait recalculée à chaque visite. Et
 * comme Googlebot n'a ni cookie ni stockage local, il continue de voir la
 * vitrine — la redirection ne le concerne jamais.
 *
 * `?vitrine=1` la neutralise, pour que la page marketing reste consultable
 * (campagnes, relecture, capture d'écran) même connecté.
 */
export function LandingRedirect() {
  const router = useRouter();
  const user = useAuthStore((s) => s.user);
  const guestAddress = useAddressStore((s) => s.guestAddress);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!user && !guestAddress) return;
    if (new URLSearchParams(window.location.search).has("vitrine")) return;
    setLeaving(true);
    // `replace` : la vitrine ne doit pas s'intercaler dans l'historique, sinon
    // le retour arrière depuis /home y ramène et repart en boucle.
    router.replace("/home");
  }, [user, guestAddress, router]);

  if (!leaving) return null;

  // Le HTML de la vitrine est déjà peint quand ce composant s'exécute : sans
  // ce voile, on verrait défiler le marketing avant la bascule.
  return (
    <div
      className="fixed inset-0 z-[95]"
      style={{ backgroundColor: "var(--fast-secondary)" }}
      aria-hidden="true"
    />
  );
}
